/**
 * Default action types for async operations (Request/Success/Failure pattern)
 */
const defaultTypes = ['REQUEST', 'SUCCESS', 'FAILURE'] as const;

/**
 * Action type for a single async operation phase
 */
export type ActionType = 'REQUEST' | 'SUCCESS' | 'FAILURE';

/**
 * Generated action types object
 */
export interface GeneratedActionTypes {
  REQUEST: string;
  SUCCESS: string;
  FAILURE: string;
}

/**
 * Generates standardized action types for async operations
 * 
 * @param resource - The resource identifier (should use entity keys, e.g., EK.state)
 * @param action - The action name (e.g., 'FETCH_ALL', 'CREATE', 'EDIT')
 * @param types - Optional custom action types (defaults to REQUEST/SUCCESS/FAILURE)
 * @returns Object with generated action type strings
 * 
 * @example
 * // ✅ CORRECT: Use entity keys
 * import { keys as EK } from './keys';
 * const RESOURCE = EK.state; // e.g., 'parameterProfileParameters'
 * const fetchTypes = generateAPHTypes(RESOURCE, 'FETCH_ALL');
 * // Result: { REQUEST: 'parameterProfileParameters/FETCH_ALL/REQUEST', ... }
 * 
 * @example
 * // ❌ WRONG: Don't use hardcoded strings
 * const RESOURCE = 'PARAMETER_PROFILE_PARAMETERS'; // Inconsistent with entity keys
 */
export const generateAPHTypes = (
  resource: string,
  action: string,
  types: readonly string[] = defaultTypes
): GeneratedActionTypes =>
  types.reduce(
    (aph, type) => ({
      ...aph,
      [type]: `${resource}/${action}/${type}`,
    }),
    {} as GeneratedActionTypes
  );
